import React, { Suspense, lazy } from 'react';
import PagePreloader from '~components/page-preloader';

const DigestsItemOldPageToken = lazy(() => import('./index'));

function LawsItemOldPageTokenLazy(props) {
    return (
        <Suspense fallback={<PagePreloader />}>
            <DigestsItemOldPageToken {...props} />
        </Suspense>
    );
}

export default LawsItemOldPageTokenLazy;
export { LawsItemOldPageTokenLazy };



// WEBPACK FOOTER //
// ./src/routes/laws-digests-old-item-page-token/lazy.js